import type { ResolvedMonospaceApiKey, ResolvedMonospaceServiceAccount, ResolvedMonospaceUser } from '#layers/data-model/public';
import { useOverlay } from '@nuxt/ui/composables';
import ApiKeyDialog from '#layers/access/components/ApiKeys/ApiKeyDialog.vue';

export function useApiKeyDialogs() {
	const overlay = useOverlay();

	async function createApiKey(user?: ResolvedMonospaceServiceAccount | ResolvedMonospaceUser) {
		const modal = overlay.create(ApiKeyDialog, {
			props: { userId: user?.id ?? null },
		});

		return await modal.open().result;
	}

	async function editApiKey(apiKey: ResolvedMonospaceApiKey) {
		const modal = overlay.create(ApiKeyDialog, {
			props: {
				userId: apiKey.user?.id ?? null,
				apiKey,
			},
		});

		return await modal.open().result;
	}

	return { createApiKey, editApiKey };
}
